// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { Resources } from '@shared/localizations/Resources';
import { Cursors } from '@shared/commons/Cursors';
import { PositionEdit } from '@shared/commons/cache/OrderParams/PositionEdit';
import { TerceraChartTradingOperation } from '../../Utils/ChartConstants';
import { OrderToolView } from './OrderToolView';
import { TradingToolViewType } from './TradingToolViewBase';
import { ToolSelectionType } from '../Selection';
import { OperationType } from '@shared/utils/Trading/OperationType';
import { PlacedFrom } from '@shared/utils/Trading/PlacedFrom';
import { TradingLockUtils } from '@shared/utils/TradingLockUtils';
import { IsAllowed } from '@shared/commons/IsAllowed';
export class PositionToolView extends OrderToolView {
    get isAllowOTHTrading() {
        return null;
    }
    get isAllowOTHTradingSLTP() {
        return this.terceraChartPanelContext.IsAllowedAction(TerceraChartTradingOperation.IsAllowOTHTrading);
    }
    constructor(order, getToolViewByOrderId, terceraChartPanelContext, renderer) {
        super(order, getToolViewByOrderId, terceraChartPanelContext, renderer);
        this.isOrderToolView = false;
        this.ToolViewType = TradingToolViewType.PositionToolView;
        this.Order.OnUpdate.Subscribe(this.onPositionDataUpdated, this);
    }
    get Collapsed() {
        return super.Collapsed;
    }
    set Collapsed(value) {
        if (this.collapsed != value) {
            super.Collapsed = value;
            // установка коллапсед у дочерних сл/тп ордеров
            if (this.Order.SLOrder !== null) {
                this.GetToolViewByOrderId(this.Order.SLOrder.OrderNumber, TradingToolViewType.SLTPOrderToolView).Collapsed = this.collapsed;
            }
            else if (!isNaN(this.Order.StopLossPriceValue)) {
                this.GetToolViewByOrderId(this.Order.OrderNumber + '-SL', TradingToolViewType.SLTPOrderToolView).Collapsed = this.collapsed;
            }
            if (this.Order.TPOrder !== null) {
                this.GetToolViewByOrderId(this.Order.TPOrder.OrderNumber, TradingToolViewType.SLTPOrderToolView).Collapsed = this.collapsed;
            }
            else if (!isNaN(this.Order.TakeProfitPriceValue)) {
                this.GetToolViewByOrderId(this.Order.OrderNumber + '-TP', TradingToolViewType.SLTPOrderToolView).Collapsed = this.collapsed;
            }
        }
    }
    Dispose() {
        this.Order.OnUpdate.UnSubscribe(this.onPositionDataUpdated, this);
        super.Dispose();
    }
    FinishMove() {
        var _a, _b;
        const toolSelectionType = this.CurrentSelection.MouseDownHover;
        if (toolSelectionType !== ToolSelectionType.SL && toolSelectionType !== ToolSelectionType.TP) {
            if (((_a = this.Order) === null || _a === void 0 ? void 0 : _a.SLOrder) != null && this.slTrade != null) {
                this.slTrade.TradeWasModified = false;
                this.slTrade.priceValue = NaN;
                if (this.sllTrade != null) {
                    this.sllTrade.TradeWasModified = false;
                    this.sllTrade.priceValue = NaN;
                }
            }
            if (((_b = this.Order) === null || _b === void 0 ? void 0 : _b.TPOrder) != null && this.tpTrade != null) {
                this.tpTrade.TradeWasModified = false;
                this.tpTrade.priceValue = NaN;
            }
        }
        super.FinishMove();
    }
    AllowCancelOrder() {
        return false;
    }
    AllowModify() {
        return false;
    }
    AllowClosePosition() {
        return IsAllowed.IsPositionClosingAllowed(this.Order, true).Allowed;
    }
    SlTpComparePrice(isForSL) {
        const pos = this.Order;
        const acc = pos.Account;
        const ins = pos.Instrument;
        const quote = ins.LastQuote;
        const isBuy = pos.BuySell === OperationType.Buy;
        return PositionEdit.SlTpPriceGetter(isForSL, isBuy, pos, ins, acc, quote);
    }
    SlComparePrice() {
        return this.SlTpComparePrice(true);
    }
    TpComparePrice() {
        return this.SlTpComparePrice(false);
    }
    get ID() {
        return this.Order != null ? this.Order.PositionId : '-2';
    }
    DescriptionText() {
        const pos = this.Order;
        const profitValue = pos.getNetPnL(true);
        return pos.Account.formatPrice(profitValue);
    }
    /// <summary>
    /// Order Draw
    /// </summary>
    Draw(gr, window, param) {
        if (!this.myRenderer.ShowPositions) {
            return;
        }
        super.Draw(gr, window, param);
    }
    // public override Dispose (): void {
    //     super.Dispose();
    // // ++
    // }
    CheckMinDistanceForStartMoving(x, y) {
        const mouseDownHover = this.CurrentSelection.MouseDownHover;
        if (mouseDownHover === ToolSelectionType.SL || mouseDownHover === ToolSelectionType.TP) {
            return Math.abs(this.CurrentMovement.PrevY - y) >= this.MinDistanceForStartMoving();
        }
        return false;
    }
    // mouse up
    ProcessClick() {
        if (!this.TradeWasModified) // click
         {
            switch (this.CurrentSelection.MouseDownHover) {
                case ToolSelectionType.Icon:
                case ToolSelectionType.Info:
                case ToolSelectionType.Image:
                case ToolSelectionType.Leverage:
                    this.Collapsed = !this.Collapsed;
                    this.ResetMouse();
                    break;
                // case ToolSelectionType.Action:
                //     if (!Utils.TradingLock.tradingLocked)
                //         this.terceraChartPanelContext.ChartVisualTrading(this.Order, { action: TerceraChartTradingOperation.ActionButton, isPosition: true });
                //     // show menu
                //     break;
                case ToolSelectionType.Remove:
                    if (!TradingLockUtils.TradingLock.tradingLocked) {
                        this.terceraChartPanelContext.ChartVisualTrading(this.Order, {
                            action: TerceraChartTradingOperation.ClosePosition,
                            sendFrom: PlacedFrom.WEB_CHART_VISUAL
                        });
                    }
                    break;
                case ToolSelectionType.Line:
                case ToolSelectionType.None:
                case ToolSelectionType.SL:
                case ToolSelectionType.TP:
                case ToolSelectionType.Trailing:
                default:
                    break;
            }
        }
    }
    GetCursor(e) {
        const curElement = this.CurrentSelection.MouseDownHover === ToolSelectionType.None
            ? this.CurrentSelection.CurrentHover
            : this.CurrentSelection.MouseDownHover;
        switch (curElement) {
            case ToolSelectionType.SL:
            case ToolSelectionType.TP:
                return this.AllowSLTP() ? (this.errorMode ? Cursors.No : Cursors.NoMoveVert) : null;
            case ToolSelectionType.Image:
                return null;
            case ToolSelectionType.Info:
            case ToolSelectionType.Action:
            case ToolSelectionType.Remove:
            case ToolSelectionType.Line:
            case ToolSelectionType.None:
            case ToolSelectionType.Trailing:
            default:
                return null;
        }
    }
    GetTooltip(e) {
        let res = '';
        switch (this.CurrentSelection.CurrentHover) {
            case ToolSelectionType.Image:
                res = Resources.getResource('TradeTool.Position');
                break;
            case ToolSelectionType.Info:
                res = Resources.getResource('TradeTool.Position P/L');
                break;
            case ToolSelectionType.Remove:
                res = Resources.getResource('TradeTool.Close position');
                break;
            default:
                res = null;
                break;
        }
        return res || super.GetTooltip(e);
    }
    onPositionDataUpdated(position) {
        this.Updated(position, true);
    }
}
